<style lang="less" scoped>
    .certificationManage {
            display: flex;
            overflow-y: hidden;
            .left {
                position: relative;
                width: 400px;
                /deep/.ivu-tree-title{
                  width: 90%;
                }
             }
             .right {
                flex: 1;
                overflow: auto;
                .qualification-table {
                  /deep/ .demo-table-warrning-row {
                    background: #f8f8f9;
                  }
                }
              }
    }

</style>
<template>
  <div 
    class="certificationManage"
    :style="{
      height:containHeight+'px'
    }"
  >
    <div class="left">
      <Spin
        v-if="loading.getSubjectsLoading"
        fix
      />
      <Tree
        ref="tree"
        :data="treeData"
        @on-select-change="selected_dis_item_fun"
      />
    </div>
    <div class="right">
      <div>
        <Collapse v-model="collapse">
          <Panel name="1">
            主体信息
            <div slot="content">
              <SubjectInfor :subject-infor="selected_dis_item" />
            </div>
          </Panel>
          <Panel name="2">
            资质信息
            <div slot="content">
              <Button
                v-show="selected_dis_item"
                size="small"
                type="primary"
                style="margin:0 0 10px 0"
                @click="q_modal_display=1"
              >
                创建企业资质
              </Button>
              <Table
                size="small"
                class="qualification-table"
                :loading="loading.getQualificationListLoading"
                :columns="qualificationListFields"
                :data="qualificationList"
                :row-class-name="rowClassName"
              />
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>
    <EditModal 
      :display="modal_display"
      :list="subjects"
      :form-props="selected_item"
      :save-loading="loading.updateSubjectItemLoading"
      @ok="updateSubjectFun"
      @cancel="modal_display=0"
    />
    <DisabledAndStart 
      :form-props="disabled_start_item"
      :save-loading="loading.changeSubjectItemStatusLoading"
      :modal-type="1"
      @ok="changeSubjectItemFun"
      @cancel="disabled_start_item=null"
    />
    <DisabledAndStart 
      :form-props="disabled_start_qualification_item"
      :save-loading="loading.changeQualificationItemStatusLoading"
      :modal-type="2"
      @ok="changeQualificationItemFun"
      @cancel="disabled_start_qualification_item = null"
    />
    <EditModalqualification 
      :form-props="selected_qualification_item"
      :selected-subject="selected_dis_item"
      :display="q_modal_display"
      :save-loading="loading.updateQualificationLoading"
      @ok="updateQualificationFun"
      @cancel="q_modal_display = 0"
    />
    <HistoryListModal
      :display="show_history"
      :form-props="historiesVersionsList"
      :loading="loading.getHistoriesVersionsLoading"
      @close="show_history = false;setStateLevel0({ key:'historiesVersionsList', value:[] })"
    />
  </div>
</template>
<script route="/legal_affairs/certification_manage">
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { NAME_SPACE, EDIT, FROZEN, HISTORY } from './constants'
  import { qualification_list_fields } from './fields'
  import { columnFile } from './utils'
  import { gotoQualificationFileApi } from './service'
  import EditModal from './components/EditModal'
  import DisabledAndStart from './components/DisabledAndStart'
  import SubjectInfor from './components/SubjectInfor'
  import EditModalqualification from './components/EditModalqualification'
  import HistoryListModal from './components/HistoryListModal'
  export default {
    components: {
      EditModal,
      DisabledAndStart,
      SubjectInfor,
      EditModalqualification,
      HistoryListModal
    },
    data() {
      return {
        modal_display: 0, // 资质主体弹窗 
        q_modal_display:0, // 资质弹窗
        show_history:false,
        selected_item:null,
        selected_dis_item: null,
        selected_qualification_item: null,
        disabled_start_item:null,
        disabled_start_qualification_item:null,
        collapse: ['1', '2'],
      }
    },
    computed: {
      ...mapState(NAME_SPACE, {
        loading: 'loading',
        subjects: 'subjects',
        historiesVersionsList:'historiesVersionsList',
        qualificationList:'qualificationList'
      }),
      treeData() {
        return [{
          company_name: '主体',
          expand: true,
          disabled: true,
          render:this.treeRender,
          children: this.subjects.map(item => ({
            ...item,
            render:this.treeRender,
          }))
        }]
      },
      qualificationListFields() {
        const _this = this
        const columns = qualification_list_fields.reduce((total, item) => {
          total.push(item)
          if (item.key === 'name') {
            total.push(columnFile.call(_this, gotoQualificationFileApi))
          }
          return total
        }, [])
        return columns.concat([{
          title:'操作',
          key: 'options',
          align: 'center',
          minWidth:120,
          render(h, { row }) {
            return h('div', {}, [
              h('Dropdown', {
                on: {
                  'on-click':(value) => {
                    switch (value) {
                    case EDIT:
                      _this.q_modal_display = 2
                      _this.selected_qualification_item = row
                      break;
                    case FROZEN:
                      _this.disabled_start_qualification_item = row
                      break;
                    case HISTORY:
                      _this.show_history = true
                      _this.getHistoriesVersions({
                        item_id: row.id,
                        fail() {
                          _this.show_history = false
                        }
                      })
                      break;
                    
                    default:
                      break;
                    }
                  }
                },
              }, [
                h('a', {
                  props: {
                    href: 'javascript:void(0)'
                  }
                }, [
                  '操作',
                  h('Icon', {
                    props: {
                      type:"ios-arrow-down"
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot:"list"
                }, [
                  h('DropdownItem', {
                    props: {
                      name: EDIT
                    }
                  }, '编辑'),
                  h('DropdownItem', {
                    props: {
                      name: FROZEN
                    }
                  }, row.has_frozen ? '解冻' : '冻结'),
                  h('DropdownItem', {
                    props: {
                      name: HISTORY
                    }
                  }, '历史记录'),
                ])
              ])
            ])
          }
        }])
      },
      containHeight() {
        const window_height = this.$store.state.window_height;
        return window_height - 166;
      }
    },
    destroyed() {
      this.initData()
    },
    mounted() {
      const _this = this
      this.getSubjectList({
        call(data) {  
          if (!data || !data.length) {
            return 
          }
          _this.selected_dis_item_fun(data)
          _this.$nextTick(() => {
            const selected_node = _this.$refs.tree.flatState.filter(item => {
              return item.node.id === data[0].id
            })[0]
            _this.$refs.tree.handleSelect(selected_node.nodeKey)
          })
        }
      })
    },
    methods: {
      ...mapMutations(NAME_SPACE, [
        'setStateLevel0',
        'initData'
      ]),
      ...mapActions(NAME_SPACE, [
        'getSubjectList',
        'updateSubjectItem',
        'changeSubjectItemStatus',
        'getHistoriesVersions',
        'updateQualification',
        'getQualificationList',
        'changeQualificationItemStatus'
      ]),
      treeRender(h, { data }) {
        // 根节点
        const children_h = (h, data) => [
          h('Button', {
            style: {
              'margin-right': '5px'
            },
            props: {
              type: 'default',
              size: 'small',
              icon: data.has_frozen ? 'ios-eye' : 'ios-eye-off'
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                this.disabled_start_item = data
              }
            }
          }),
          h('Button', {
            props: {
              type: 'default',
              size: 'small',
              icon: 'ios-build'
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                this.modal_display = 2
                this.selected_item = data
              }
            }
          })
        ]
        // 子节点
        const parent_h = (h) => [ h('Button', {
          props: {
            type: 'default',
            size: 'small',
            icon: 'ios-add'
          },
          on: {
            click: (e) => {
              e.stopPropagation();
              this.modal_display = 1
              this.selected_item = null
            }
          }
        })]
        return h('span', {
          style: {
            display: 'block',
            width: '100%'
          }
        }, [
          h('span', {
            style: {
              display: 'inline-block',
              width: '60%',
              // text-decoration:line-through
              color:data.has_frozen ? '#C0C0C0' : '',
              'text-decoration':  data.has_frozen ? 'line-through' : ''
            }
          }, data.company_name),
          h('span', {
            style: {
              display: 'inline-block',
              'text-align':'right',
              width: '40%'
            }
          }, data.id ? children_h(h, data) : parent_h(h, data))
        ]);
      },
      // 展示主体信息
      selected_dis_item_fun([ item ]) {
        if (this.selected_dis_item && item && this.selected_dis_item.id === item.id) {
          return 
        }
        this.selected_dis_item = item || null
        if (item) {
          this.getQualificationList({ subject_id: item.id })
        } else {
          this.setStateLevel0({ key:'qualificationList', value:[] })
        }
      },
      // 更新，新增条目
      updateSubjectFun(params) {
        this.updateSubjectItem({...params, updateSelect:this.update_selected_dis_item})
      },
      // 修改主体状态
      changeSubjectItemFun(params) {
        this.changeSubjectItemStatus({...params, updateSelect:this.update_selected_dis_item})
      },
      // 修改资质状态
      changeQualificationItemFun({ call }) {
        const id = this.disabled_start_qualification_item.id
        const subject_id = this.selected_dis_item.id
        this.changeQualificationItemStatus({ id, subject_id, call })
      },
      // 新增、编辑、冻结、解冻 对选中条目进行更新
      update_selected_dis_item(list) {
        if (!this.selected_dis_item) {
          return
        }
        const { id } = this.selected_dis_item
        this.selected_dis_item = list.filter(item => id === item.id)[0]
        this.$nextTick(() => {
          const selected_node = this.$refs.tree.flatState.filter(item => {
            return item.node.id === id
          })[0]
          this.$refs.tree.handleSelect(selected_node.nodeKey)
        })
      },
      // 上传资质
      updateQualificationFun(data) {
        this.updateQualification({
          s_params:data,
          subject_id:this.selected_dis_item.id
        })
      },
      // table行样式
      rowClassName(row) {
        if (row.has_frozen) {
          return 'demo-table-warrning-row';
        }
        return '';
      }
    },
  }
</script>
